import axios, { Axios } from 'axios';
import { ActionTree, Module, MutationTree } from 'vuex';
import { namespace } from 'vuex-class';

import { Config } from '@/models/config.model';

import { RootState } from './index';


/**
 *
 * State
 *
 */
export type ConfigState = Config;

const makeInitialState = (): ConfigState => ({
  processRolloverDate: '',
});

const state = makeInitialState;


/**
 *
 * Mutations
 *
 */
const mutations: MutationTree<ConfigState> = {
  reset(state) {
    const initialState = makeInitialState();
    for (const key in initialState) {
      if (initialState.hasOwnProperty(key)) {
        state[key] = initialState[key];
      }
    }
  },

  setValues(state, value: Config) {
    for (const key in value) {
      if (value.hasOwnProperty(key)) {
        state[key] = value[key];
      }
    }
  },
};


/**
 *
 * Actions
 *
 */
interface ConfigActions {
  fetch: () => Promise<void>;
  reset: () => void;
}

const actions: ActionTree<ConfigState, RootState> = {
  async fetch(store) {
    const result = (await axios.get('/config')).data;
    store.commit('setValues', result);
  },

  reset(store) {
    store.commit('setValues', makeInitialState());
  },
};


export default {
  namespaced: true,
  actions,
  mutations,
  state,
} as Module<ConfigState, RootState>;


// eslint-disable-next-line @typescript-eslint/no-namespace
export namespace ConfigStore {
  export const Bind = namespace('config');
  export type State <TProp extends keyof ConfigState> = ConfigState[TProp];
  export type Action <TProp extends keyof ConfigActions> = ConfigActions[TProp];
}
